/* @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import styles from './AssetRequest.module.scss';
import Moment from 'react-moment';

@translate()
export default class AssetRequest extends React.Component<*> {
  render(): React.Element<*> {
    const { t, data } = this.props;
    const { details } = data;
    const { asset_request: assetRequest } = details;
    const { project, cost_centre: costCenter } = assetRequest;

    return (
      <div className={styles['asset-request-section']}>
        <div>
          <h3>{t('general:asset_request_details')}:</h3>
          <div>
            <b>{t('general:labels.requested_id')}: </b>{' '}
            <b className={styles['highlight']}>{assetRequest.unique_asset_request_id}</b>
          </div>
          <div>
            <b>{t('general:account')}: </b> {data.account_name}
          </div>
          <div>
            <b>{t('general:labels.requested_by')}: </b> {data.user_name}
          </div>
          <br />
          <div>
            <b>{t('general:labels.start_date')}: </b>
            <Moment date={assetRequest.start_date} format="MMMM DD, YYYY" />
          </div>
          <div>
            <b>{t('general:labels.end_date')}: </b>
            <Moment date={assetRequest.end_date} format="MMMM DD, YYYY" />
          </div>
          <br />
          <div>
            <div>
              <b>{t('general:project_and_cost_center')}</b>:
            </div>
            <br />
            <div>
              <b>{t('general:project_code')}: </b> {project ? project.code : 'N/A'}
            </div>
            <div>
              <b>{t('general:project')}: </b> {project ? project.name : 'N/A'}
            </div>
          </div>
          <br />
          <div>
            <div>
              <b>{t('general:cost_center_code')}: </b> {costCenter ? costCenter.code : 'N/A'}
            </div>
            <div>
              <b>{t('general:cost_center')}: </b> {costCenter ? costCenter.name : 'N/A'}
            </div>
          </div>
          <br />
          <div>
            <b>{t('general:labels.additional_info')}: </b> {assetRequest.additional_information}
          </div>
        </div>
        <div className={styles['asset-container']}>
          <h3 className={styles['asset-list-header']}>Your Assets:</h3>
          <div className={styles['asset-list-container']}>
            {assetRequest.asset_request_products.map((asset, index) => {
              return (
                <div className={styles['asset']} key={index}>
                  <h4>
                    {t('general:asset')} {index + 1}
                  </h4>
                  <div>
                    <b>{t('general:manufacturer')}: </b> {asset.manufacturer}
                  </div>
                  <div>
                    <b>{t('general:model')}: </b> {asset.product}
                  </div>
                  <div>
                    <b>{t('general:labels.quantity')}: </b> {asset.quantity}
                  </div>
                  <div>
                    <b>{t('general:labels.additional_info')}: </b> {asset.additional_info}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles['site-details-container']}>
          <div className={styles['details']}>
            <h3>{t('general:labels.customer_details')}</h3>
            <div>
              <b>{t('general:labels.contact_name')}: </b> {assetRequest.customer_contact_name}
            </div>
            <div>
              <b>{t('general:labels.contact_phone_number')}: </b>{' '}
              {assetRequest.customer_contact_phone}
            </div>
            <div>
              <b>{t('general:company')}: </b> {assetRequest.customer_site.company_name}
            </div>
            <div>
              <b>{t('general:locations.labels.site')}: </b> {assetRequest.customer_site.name}
            </div>
            <div>
              {assetRequest.customer_site.address.address_1 && (
                <div>{assetRequest.customer_site.address.address_1},</div>
              )}
              {assetRequest.customer_site.address.address_2 && (
                <div>{assetRequest.customer_site.address.address_2},</div>
              )}
              {assetRequest.customer_site.address.address_3 && (
                <div>{assetRequest.customer_site.address.address_3},</div>
              )}
              {assetRequest.customer_site.address.address_4 && (
                <div>{assetRequest.customer_site.address.address_4},</div>
              )}
              {assetRequest.customer_site.address.address_5 && (
                <div>{assetRequest.customer_site.address.address_5},</div>
              )}
              {assetRequest.customer_site.address.postcode && (
                <div>{assetRequest.customer_site.address.postcode}</div>
              )}
            </div>
          </div>
          <div className={styles['details']}>
            <h3>{t('general:labels.delivery_details')}</h3>
            <div>
              <b>{t('general:labels.contact_name')}: </b> {assetRequest.delivery_contact_name}
            </div>
            <div>
              <b>{t('general:labels.contact_phone_number')}: </b>{' '}
              {assetRequest.delivery_contact_phone}
            </div>
            <div>
              <b>{t('general:company')}: </b> {assetRequest.delivery_site.company_name}
            </div>
            <div>
              <b>{t('general:locations.labels.site')}: </b> {assetRequest.delivery_site.name}
            </div>
            <div>
              {assetRequest.delivery_site.address.address_1 && (
                <div>{assetRequest.delivery_site.address.address_1},</div>
              )}
              {assetRequest.delivery_site.address.address_2 && (
                <div>{assetRequest.delivery_site.address.address_2},</div>
              )}
              {assetRequest.delivery_site.address.address_3 && (
                <div>{assetRequest.delivery_site.address.address_3},</div>
              )}
              {assetRequest.delivery_site.address.address_4 && (
                <div>{assetRequest.delivery_site.address.address_4},</div>
              )}
              {assetRequest.delivery_site.address.address_5 && (
                <div>{assetRequest.delivery_site.address.address_5},</div>
              )}
              {assetRequest.delivery_site.address.postcode && (
                <div>{assetRequest.delivery_site.address.postcode}</div>
              )}
            </div>
            <div>
              <b>{t('general:labels.special_instructions')}: </b>{' '}
              {assetRequest.delivery_special_instructions}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
